var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.value,
        persistent: "",
        width: _vm.multiple ? "1000" : "800",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "pl-5 pr-2 pt-4 pb-2" },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "warning" } },
                [_vm._v("mdi-alert")]
              ),
              _c("div", { staticClass: "title h6" }, [
                _vm._v(" " + _vm._s(_vm.warningTitle) + " "),
              ]),
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { color: "primary" }, on: { click: _vm.generateCSV } },
                [
                  _vm._v(" Export "),
                  _c(
                    "v-icon",
                    { staticClass: "pl-2 pt-0", attrs: { size: "large" } },
                    [_vm._v(" mdi-download ")]
                  ),
                ],
                1
              ),
              _c(
                "v-card-subtitle",
                {
                  staticClass: "py-2 pl-0 pr-2 ma-0",
                  staticStyle: { "word-break": "break-word" },
                },
                [_vm._v(" " + _vm._s(_vm.warningText) + " ")]
              ),
            ],
            1
          ),
          _c("v-divider", { staticClass: "mx-4" }),
          _c(
            "v-container",
            { staticClass: "pa-0 mx-0", attrs: { fluid: "" } },
            [
              _c("v-data-table", {
                staticClass: "mx-4",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.promos,
                  "group-by": _vm.multiple ? "feature_pos" : undefined,
                  height: _vm.tableHeight,
                  "fixed-header": "",
                  dense: "",
                  "footer-props": { "items-per-page-options": [-1] },
                  "items-per-page": -1,
                },
                scopedSlots: _vm._u(
                  [
                    _vm.multiple
                      ? {
                          key: `group.header`,
                          fn: function ({
                            group,
                            items,
                            headers,
                            toggle,
                            isOpen,
                          }) {
                            return [
                              _c(
                                "td",
                                { attrs: { colspan: headers.length } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      ref: group,
                                      attrs: {
                                        dense: "",
                                        small: "",
                                        icon: "",
                                        "data-open": isOpen,
                                      },
                                      on: { click: toggle },
                                    },
                                    [
                                      isOpen
                                        ? _c("v-icon", [
                                            _vm._v("mdi-chevron-up"),
                                          ])
                                        : _c("v-icon", [
                                            _vm._v("mdi-chevron-down"),
                                          ]),
                                    ],
                                    1
                                  ),
                                  _c("span", [
                                    _c("b", [
                                      _vm._v(
                                        " " + _vm._s(items[0].feature_pos) + " "
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        }
                      : null,
                    {
                      key: `item.start_dt`,
                      fn: function ({ item }) {
                        return [
                          item.start_dt
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$dateConfig.formatDate(item.start_dt)
                                    )
                                ),
                              ])
                            : _c("span", [_vm._v("-")]),
                        ]
                      },
                    },
                    {
                      key: `item.end_dt`,
                      fn: function ({ item }) {
                        return [
                          item.end_dt
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$dateConfig.formatDate(item.end_dt)
                                    )
                                ),
                              ])
                            : _c("span", [_vm._v("-")]),
                        ]
                      },
                    },
                    {
                      key: `item.link`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "", color: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.goToPromo(item.promo_id)
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("mdi-open-in-new")])],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c(
                "div",
                { staticClass: "d-flex justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mb-4 mr-4",
                      attrs: { text: "" },
                      on: { click: _vm.close },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mb-4",
                      attrs: { color: "warning" },
                      on: { click: _vm.confirm },
                    },
                    [_vm._v(" Confirm ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }